import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

@Injectable()
export class appState {
    auth: any;
    constructor() {
        
    }

}



// WEBPACK FOOTER //
// ./src/model/appState.ts